import { createApp } from 'vue'
//import Vue from "vue"
import App from './App.vue'
//import { guest } from "./plugins/axios"

// new Vue({
//     guest,
//     render: (h) => h(App),
//   }).$mount("#app");
createApp(App).mount('#app')
